<template>
  <v-footer dark padless>
    <v-card
      style="width: 100%;"
      flat
      tile
      class="white--text text-center"
      color="#747474"
    >
      <v-card-text>
        <v-btn icon v-for="(icon, i) in icons" :key="i" :class="`mx-4 white--text`">
          <v-icon size="24px" @click="to(icon.link)">{{ icon.name }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>Quentin Mennecart</strong>
        <br />Made with ❤ with Vuetify
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
      // { name: "mdi-facebook", link: ""},
      { name: "mdi-github", link: "https://github.com/QuentinMenDev", color: "black"},
      { name: "mdi-twitter", link: "https://twitter.com/QuentinMenDev", color: "blue"},
      { name: "mdi-linkedin", link: "https://www.linkedin.com/in/quentin-mennecart-a20195110/", color: "blue"},
      { name: "mdi-instagram", link: "https://www.instagram.com/quentin.mennecart/", color:"purple"}
    ]
  }),

  methods: {
    to(link) {
      window.open(link, "_blank");
    }
  }
};
</script>

<style></style>
